import { LazyLoad } from 'app/utils';

export const CompanyActivityListPage = LazyLoad(
  () => import('./index'),
  (module) => module.CompanyActivityListPage,
);
